<template>
  <div class="banquet-check">
    <div class="banquet-apply-title banquet-section-title">申請人</div>
    <inputField
      id="name"
      label="姓名"
      :disabled="true"
      class="banquet-name"
      :value="applyInfo.name"
    />
    <inputField
      id="phone"
      label="手機號碼/聯絡電話"
      :disabled="true"
      class="banquet-phone"
      :value="applyInfo.phone"
    />
    <inputField
      id="numberOfPeople"
      label="葷食人數"
      :disabled="true"
      class="banquet-count"
      :value="headQuantityMeat"
    />
    <inputField
      id="numberOfVegetarian"
      label="素食人數"
      :disabled="true"
      class="banquet-vegetable-count"
      :value="headQuantityVegetable"
    />
    <div class="banquet-apply-info-line banquet-seperator-line" />
    <div class="banquet-section-title">費用總計</div>
    <inputField
      id="banquet-fee"
      label="費用總計"
      :disabled="true"
      class="banquet-fee"
      :value="displayFee"
    />
    <div class="banquet-seperator-line" />
    <div class="banquet-section-title">付款方式</div>
    <dropdownBtn
      v-model="payWay"
      label="選擇付款方式"
      :options="payOptions"
      class="banquet-pay-way"
    ></dropdownBtn>
    <div>
      請在20分鐘內完成付款，若付款失敗，該筆訂單將被取消，若有需要請重新下單
    </div>
    <div class="banquet-footer-steps">
      <div
        class="temple-button-text banquet-footer-previous"
        @click="previousClick"
      >
        上一步
      </div>
      <div class="temple-button-text banquet-footer-pay" @click="payClick">
        付款
      </div>
    </div>
  </div>
</template>

<script>
import store from 'Store/store';
import formater from 'Core/format.js';
import inputField from 'Components/inputField/inputField.vue';
import dropdownBtn from 'Components/dropdown/dropdown.vue';

export default {
  name: 'ServiceBanquetStep3',
  components: {
    inputField,
    dropdownBtn,
  },
  data() {
    return {
      payWay: '0',
      payOptions: [{ text: 'LINE Pay', value: '0' }],
    };
  },
  methods: {
    previousClick() {
      this.$emit('previousStep');
    },
    payClick() {
      let paymentInfo = {
        applyName: this.applyInfo.name,
        applyPhone: this.applyInfo.phone,
        headQuantity: this.headQuantity,
        vegetarian: this.headQuantityVegetable,
        price: this.fee,
        paymentType: Number(this.payWay),
        serviceId: store.state.main.onlineStatus.reposeInfo.serviceInfo.id,
        policyId: store.state.main.onlineStatus.policyInfo.id,
      };
      this.$emit('pay', paymentInfo);
    },
  },
  computed: {
    applyInfo() {
      return store.state.main.banquetApplyInfo;
    },
    countTitle() {
      return this.applyInfo.calculateType == 'desk' ? '桌數' : '人數';
    },
    headQuantityMeat() {
      let pCount =
        this.applyInfo.calculateTypeOfMeat === 'desk'
          ? Number(this.applyInfo.numberOfPeople) * 10
          : Number(this.applyInfo.numberOfPeople);
      return pCount;
    },
    headQuantityVegetable() {
      let pCount =
        this.applyInfo.calculateTypeOfVegetable === 'desk'
          ? Number(this.applyInfo.numberOfVegetarian) * 10
          : Number(this.applyInfo.numberOfVegetarian);
      return pCount;
    },
    headQuantity() {
      return this.headQuantityMeat + this.headQuantityVegetable;
    },
    fee() {
      let unitPrice = store.state.main.onlineStatus.reposeInfo.unitPrice || 0;
      let discountPrice =
        store.state.main.onlineStatus.reposeInfo.discountInfo.price || 0;
      let discountCountUnit =
        store.state.main.onlineStatus.reposeInfo.discountInfo.conditionCount ||
        0;
      if (discountCountUnit <= 0) {
        discountCountUnit = 1;
      }
      let discountCount = Math.floor(this.headQuantity / discountCountUnit);
      let total = this.headQuantity * unitPrice - discountCount * discountPrice;
      return total;
    },
    displayFee() {
      let total = this.fee;
      let strTotal = formater.thousandComma(total);
      return `${strTotal}元`;
    },
  },
};
</script>

<style scoped>
.banquet-check {
  margin: 0px 5px 0px 5px;
}

.banquet-section-title {
  font-size: 16px;
  font-weight: bold;
  color: #b18147;
}

.banquet-apply-title {
  margin-top: 50px;
}

.banquet-name,
.banquet-phone,
.banquet-count,
.banquet-vegetable-count,
.banquet-fee,
.banquet-pay-way {
  margin-top: 10px;
}

.banquet-footer-steps {
  margin-top: 50px;
  align-items: center;
  display: flex;
  justify-content: center;
}

.banquet-footer-previous {
  margin-right: 15px;
}

.banquet-footer-pay {
  margin-left: 15px;
}

.banquet-seperator-line {
  margin: 50px 0px 50px 0px;
  height: 1px;
  background-color: #000000;
}

@media (min-width: 768px) {
  .banquet-name,
  .banquet-phone,
  .banquet-count,
  .banquet-vegetable-count,
  .banquet-fee,
  .banquet-pay-way {
    width: calc(50% - 20px);
  }

  .banquet-name,
  .banquet-count {
    float: left;
  }

  .banquet-phone,
  .banquet-vegetable-count {
    float: right;
  }

  .banquet-footer-steps {
    margin-top: 150px;
  }

  .banquet-apply-info-line {
    margin-top: 230px;
  }
}
</style>
